<template>
    <v-row class="justify-center">
        <v-col
            cols="12"
            sm="8"
            md="4"
            lg="3"
            style="min-width: 312px; max-width: 400px"
            class="flex justify-center"
            :class="$vuetify.breakpoint.xs ? 'pa-2' : 'pa-4'"
            v-for="card in cards"
            :key="card.title"
        >
            <v-hover v-slot="{ hover }">
                <v-card
                    class="soli-round w-full"
                    hover
                    light
                    style="border: none"
                    :elevation="hover ? 6 : 2"
                    :class="{
                        'on-hover': hover,
                        'mx-3': $vuetify.breakpoint.smAndUp,
                        'mx-auto': $vuetify.breakpoint.xs,
                    }"
                    @click="$emit('input', card.value)"
                >
                    <v-img
                        height="250"
                        :src="card.src"
                        :lazy-src="card.lazy"
                        class="align-end"
                        gradient="to bottom, rgb(255 255 255 / 0%), rgba(25, 73, 114, .75)"
                        v-if="$vuetify.breakpoint.mdAndUp"
                    >
                        <v-card-title
                            class="white--text font-weight-bold text-h5"
                            >{{ card.title }}</v-card-title
                        >
                    </v-img>
                    <v-card-actions
                        class="flex justify-start my-2"
                        v-if="$vuetify.breakpoint.mdAndUp"
                    >
                        <v-btn class="soli-round soli-blue-text font-weight-bold" text small
                            ><span :class="{ underline: hover }">{{
                                card.subtitle
                            }}</span>
                            <v-icon small>chevron_right</v-icon></v-btn
                        >
                    </v-card-actions>
                    <v-card-actions v-if="$vuetify.breakpoint.smAndDown">
                        <v-list>
                            <v-card-title
                                class="font-weight-bold soli-grey pb-0"
                                >{{ card.title }}</v-card-title
                            >
                            <v-btn
                                class="soli-round ml-1"
                                text
                                small
                                color="primary"
                                ><span :class="{ underline: hover }">{{
                                    card.subtitle
                                }}</span>
                                <v-icon small>chevron_right</v-icon></v-btn
                            ></v-list
                        ><v-spacer />
                        <v-avatar size="96" class="soli-round"
                            ><v-img
                                :src="card.src"
                                :lazy-src="card.lazy"
                                class="align-end"
                                gradient="to bottom, rgb(255 255 255 / 0%), rgba(25, 73, 114, .75)"
                            ></v-img></v-avatar
                    ></v-card-actions>
                    <!--<v-img
                        v-if="$vuetify.breakpoint.smAndDown"
                        height="120"
                        :src="card.src"
                        :lazy-src="card.lazy"
                        class="align-end"
                        gradient="to left, rgb(255 255 255 / 0%), rgba(25, 73, 114, 1)"
                    >
                        <v-card-title
                            class="white--text font-weight-bold text-h5 pb-0"
                            >{{ card.title }}</v-card-title
                        ><v-btn class="soli-round ml-1" text small color="white"
                            ><span :class="{ underline: hover }">{{
                                card.subtitle
                            }}</span>
                            <v-icon small>chevron_right</v-icon></v-btn
                        >
                    </v-img>-->
                </v-card></v-hover
            >
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        cards: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            hover: false,
        };
    },
};
</script>
